export default __webpack_public_path__ + "static/Claimdi_logo-8b0ad475a5aea5197da861e2d9197b3d.png";